import { FlowRoute } from 'utils/FlowProvider/types'
import { getFlow } from 'utils/FlowProvider/utils'
import { isDynamicFunnelEnabled } from 'utils/FunnelContext/utils'

type PageViewEventFields = {
  object_name: string
  screen: string
  screen_name: string
  platform?: string
}

const laterOnboardingPageViewEvents = new Map<string, PageViewEventFields>([
  [
    FlowRoute.Welcome,
    {
      object_name: 'laterRegistrationInterstitial',
      screen: 'laterRegistrationInterstitial',
      screen_name: 'laterRegistrationInterstitial',
    },
  ],
  [
    FlowRoute.LaterIraRecommendation,
    {
      object_name: 'laterRegistrationIRARecommendation',
      screen: 'laterRegistrationIRARecommendation',
      screen_name: 'laterRegistrationIRARecommendation',
    },
  ],
  [
    FlowRoute.RecurringInvestment,
    {
      object_name: 'laterRegistrationRecurringInvestment',
      screen: 'laterRegistrationRecurringInvestment',
      screen_name: 'laterRegistrationRecurringInvestment',
    },
  ],
  [
    FlowRoute.Institutions,
    {
      object_name: 'laterRegistrationLinkBankSearch',
      screen: 'laterRegistrationLinkBankSearch',
      screen_name: 'laterRegistrationLinkBankSearch',
    },
  ],
  // TODO: DBI
  [
    '/institution/link',
    {
      object_name: 'laterRegistrationLinkDirectBank',
      screen: 'laterRegistrationLinkDirectBank',
      screen_name: 'laterRegistrationLinkDirectBank',
    },
  ],
  [
    FlowRoute.BankLinkSuccess,
    {
      object_name: 'laterRegistrationLinkBankAccountLinked',
      screen: 'laterRegistrationLinkBankAccountLinked',
      screen_name: 'laterRegistrationLinkBankAccountLinked',
    },
  ],
  [
    FlowRoute.Success,
    {
      object_name: 'laterRegistrationCongratulations',
      screen: 'laterRegistrationComplete',
      screen_name: 'laterRegistrationComplete',
    },
  ],
])

const defaultPageViewEvents = new Map<string, PageViewEventFields>([
  [
    FlowRoute.ChooseFundingSource,
    {
      object_name: 'registrationLinkBankSelectChecking',
      screen: 'registrationLinkBankSelectChecking',
      screen_name: 'registrationLinkBankSelectChecking',
    },
  ],
  // TODO: DBI
  [
    '/institution/link',
    {
      object_name: 'registrationLinkDirectBank',
      screen: 'registrationLinkDirectBank',
      screen_name: 'registrationLinkDirectBank',
    },
  ],
  [
    FlowRoute.LaterSuitabilityQuestions,
    {
      object_name: 'registrationPortfolioQuestionsPartOne',
      screen: 'registrationPortfolioQuestionsPartOne',
      screen_name: 'registrationPortfolioQuestionsPartOne',
    },
  ],
  [
    FlowRoute.RecurringInvestment,
    {
      object_name: 'registrationInitialInvestmentRecurring',
      screen: 'registrationInitialInvestmentRecurring',
      screen_name: 'registrationInitialInvestmentRecurring',
    },
  ],
  [
    FlowRoute.RoundUpsFunding,
    {
      object_name: 'registrationRoundUpsFunding',
      screen_name: 'registrationRoundUpsFunding',
      screen: 'registrationRoundUpsFunding',
    },
  ],
  [
    FlowRoute.Success,
    {
      object_name: 'registrationSuccess',
      screen: 'registrationSuccess',
      screen_name: 'registrationSuccess',
    },
  ],
  [
    FlowRoute.SuitabilityQuestions,
    {
      object_name: 'registrationPortfolioQuestions',
      screen: 'registrationPortfolioQuestions',
      screen_name: 'registrationPortfolioQuestions',
    },
  ],
  [
    FlowRoute.RoundUpsFunding,
    {
      object_name: 'registrationRoundUpsFunding',
      screen_name: 'registrationRoundUpsFunding',
      screen: 'registrationRoundUpsFunding',
    },
  ],
])

/**
 * THIS IS DEPRECATED. DO NOT USE THIS FUNCTION.
 * We are moving towards using generated events (generated/trackingEvents).
 */
export const getPageViewEvent = (location) => {
  let eventData
  const pathname =
    location.pathname === FlowRoute.Welcome
      ? location.pathname
      : location.pathname.replace(/\/$/, '')
  switch (!isDynamicFunnelEnabled() && getFlow()) {
    case 'laterOnboarding': {
      return (eventData = laterOnboardingPageViewEvents.get(pathname))
    }
    default: {
      eventData = defaultPageViewEvents.get(pathname)
    }
  }

  return eventData || {}
}
